export default __webpack_public_path__ + "static/media/Cardview-Default.17f849cf.svg";